import { useContext } from "react";
import CartOrderContext from "../providers/CartOrderProvider";

const useCartOrderContext = () => {
    const cartOrderContext = useContext(CartOrderContext);
    if (!cartOrderContext) {
        throw new Error('CartOrderContext has to be used within <CartOrderContext.Provider>');
    } else {
        return cartOrderContext
    }
}

export default useCartOrderContext;